import { render, staticRenderFns } from "./farm.vue?vue&type=template&id=2a11bbac&scoped=true"
import script from "./farm.vue?vue&type=script&lang=js"
export * from "./farm.vue?vue&type=script&lang=js"
import style0 from "./farm.vue?vue&type=style&index=0&id=2a11bbac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a11bbac",
  null
  
)

export default component.exports